import axios from 'axios'
import store from '../store'
import endpoint from '@constants/apipath'
import appConfig from '@/appconfig'
import common from '@state/modules/common'

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  async getRateSheetData({ commit }, customerId) {
    let url = `${appConfig.apiEndPoint}${endpoint.adminApiPath.getRateSheet}?customerId=${customerId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        console.log(error)
      })
  },

  async postRateSheetData({ commit }, payload) {
    let url = `${appConfig.apiEndPoint}${endpoint.adminApiPath.saveRateSheet}`
    return axios
      .post(url, payload, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        console.log(error)
        var errorMsg = common.displayModelErrors(error.response)
        if (errorMsg !== '') {
          alert(errorMsg)
        } else {
          return error
        }
      })
  },
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
  }
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.access_token
    : ''
}
